
import { PropType, defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import useNumbers from '@/composables/useNumbers';
import usePool22Query from '@/composables/queries/usePool22Query';
import { DecoratedPoolWithShares } from '@/services/balancer/subgraph/types';

export default defineComponent({
  props: {
    pool: { type: Object as PropType<DecoratedPoolWithShares> },
    loading: { type: Boolean, default: true }
  },

  setup(props) {
    // COMPOSABLES
    const { fNum } = useNumbers();
    const { t } = useI18n();
    // COMPUTED
    const stats = computed(() => {
      if (!props.pool) return [];
      const pool22Query = usePool22Query(props.pool.id);
      let wptPrice = 0;
      const leftTotalBalance = pool22Query.data.value?.tokens[0].token.totalBalanceUSD;
      const rightTotalBalance = pool22Query.data.value?.tokens[1].token.totalBalanceUSD;

      if (rightTotalBalance && leftTotalBalance) {
        wptPrice = parseFloat(rightTotalBalance) / parseFloat(leftTotalBalance);
      }

      return [
        {
          id: 'apr',
          label: 'Pool APR',
          value: fNum(props.pool.apr.total, 'percent')
        },
        {
          id: 'wptPrice',
          label: 'MPT price',
          value: fNum(wptPrice, 'usd')
        },
        {
          id: 'poolValue',
          label: t('poolValue'),
          value: fNum(props.pool.totalLiquidity, 'usd')
        },
        {
          id: 'volumeTime',
          label: t('volumeTime', ['24h']),
          value: fNum(props.pool.volume24h, 'usd')
        },
        {
          id: 'feesTime',
          label: t('feesTime', ['24h']),
          value: fNum(props.pool.fees24h, 'usd')
        },
        {
          id: 'incentive',
          label: 'Liquidity incentives',
          value: `~ ${fNum(props.pool.decoratedFarm ? props.pool.decoratedFarm.rewards : 0, 'usd')} / day`,
        }
      ];
    });

    return {
      stats
    };
  }
});
